import { render, staticRenderFns } from "./ClientStatusTable.vue?vue&type=template&id=229b4c85&scoped=true&"
import script from "./ClientStatusTable.vue?vue&type=script&lang=js&"
export * from "./ClientStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientStatusTable.vue?vue&type=style&index=0&id=229b4c85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b4c85",
  null
  
)

export default component.exports